import axios from "@/helpers/axios";
import * as logger from "@/helpers/logger";

var editor = {
  data() {
    return {
      isEdit: false,
      imageAdded: []
    };
  },
  mounted() {
    var editor = this.$refs.vueEditor;
    if (editor && editor.value) {
      this.isEdit = true;
    }
  },
  methods: {
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("image", file);
      let type = "";
      const image = ["jpeg", "jpg", "png"];
      for (let values of formData.values()) {
        type = values.type;
      }
      if (image.includes(type.replace("image/", ""))) {
        axios.post("/media", formData).then(response => {
          let imageData = response.data.payload.transforms.find(
            element => element.id === "original"
          ); // Get url from response
          Editor.insertEmbed(cursorLocation, "image", imageData.location);
          this.imageAdded = [...this.imageAdded, imageData.location];
          resetUploader();
        });
      }
    },
    handleImageRemoved(image) {
      let imageSrc = image.split("/");
      var isNewImage = this.imageAdded.includes(image);
      imageSrc.splice(0, 3);
      let imageUrl = imageSrc.join("/");
      const sizes = ["thumbnail", "medium", "original"];
      const defaultSize = "original";
      if (!this.isEdit || isNewImage) {
        for (var size of sizes) {
          // Delete image
          axios
            .post("/media/delete", {
              key: imageUrl.replace(defaultSize, size)
            })
            .then(async () => {})
            .catch(error => {
              logger.error(error);
            });
        }
      }
    },
    handleTextChange(delta) {
      var text = delta.ops;
      text.map(e => {
        if (e.attributes && e.attributes.align) {
          setTimeout(() => {
            document.querySelector(".ql-align").classList.remove("ql-active");
            document
              .querySelector(`.ql-align[value="${e.attributes.align}"]`)
              .classList.add("ql-active");
          }, 10);
        }
      });
      const quillContainer = this.$refs.vueEditor.$refs.quillContainer;
      text.map(e => {
        if (e.attributes && e.attributes.link) {
          let url = e.attributes.link;
          if (!this.validateUrl(url)) {
            quillContainer.querySelector(`a[href="${url}"]`).remove();
            this.$toastr.warning("Invalid url link", "Warning");
          }
        }
      });
    },
    onSelection(range) {
      let editor = document.querySelector(".ql-editor");
      if (range) {
        let index = range.index - editor.textContent.length;
        let contents = editor.childNodes[index];
        document.querySelectorAll(".ql-align").forEach(el => {
          if (contents && contents.classList.value.includes(el.value)) {
            document.querySelector(".ql-align").classList.remove("ql-active");
            document
              .querySelector(`.ql-align[value="${el.value}"]`)
              .classList.add("ql-active");
          }
        });
      }
    },
    validateUrl(url) {
      let pattern = /^((http|https|ftp):\/\/)/;
      return pattern.test(url);
    }
  }
};
export default editor;
